export default "__VITE_ASSET__d_UHSQRS__"